import {Directive, ElementRef, OnInit, Input} from '@angular/core';

declare var $:any;

@Directive({
    selector: "[altDatepicker]"
})
export class UiDatepickerAltDirective implements OnInit {

    @Input() altDatepicker: any;

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        let element = $(this.el.nativeElement);
        let datepickerEl;

        if (!!this.altDatepicker) {
            datepickerEl = $(this.altDatepicker);
        }
        if (!datepickerEl || !datepickerEl.is("[datepicker]")) {
            datepickerEl = element.prev("[datepicker]")
        }

        if (datepickerEl.is("[datepicker]")) {
            datepickerEl.hide();
            element.on("click", () => datepickerEl.datepicker("show"));
        }
    }
}